import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';

type OrderConfirmationType = PageType;

export default (currentPage: PageType): currentPage is OrderConfirmationType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_AppShell_Partials_AppShellViewModel;
};
